import { Injectable } from '@angular/core';
import { McticHttpClient } from '@mctic/ng-core';
import { Observable } from 'rxjs';
import { publishReplay, refCount } from 'rxjs/operators';
import { Regiao } from '../shared/model';

@Injectable({
  providedIn: 'root'
})
export class RegiaoService {

  private readonly endpoint = '/sepin-backend/rest/regioes';

  private observable: Observable<Regiao[]>;

  constructor(private readonly http: McticHttpClient) {
  }

  obterTodas() {
    if (!this.observable) {
      this.observable = this.http.get<Regiao[]>(this.endpoint);
    }

    return this.observable;
  }

  obterRegioesPorIdAnoBase(idAnoBase: number) {
    return this.http.get(`${this.endpoint}/ano-base/${idAnoBase}`);
  }

  obterRegioesPorNumeroAnoBase(anoBase: number) {
    return this.http.get(`${this.endpoint}/ano-base/numero/${anoBase}`);
  }

}
